export const ApiKeyScope = {
  Read: "read",
  ReadWrite: "read_write",
} as const

export type ApiKeyScope = typeof ApiKeyScope[keyof typeof ApiKeyScope]
